/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Range_UsdInputs */

const en_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range (USD)`)
};

const es_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango de precio (USD)`)
};

const fr_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fourchette de prix (USD)`)
};

const de_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisspanne (USD)`)
};

const ja_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格帯 (USD)`)
};

const zh_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格范围 (美元)`)
};

const ar_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق السعر (بالدولار الأمريكي)`)
};

const id_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rentang Harga (USD)`)
};

const it_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fascia di Prezzo (USD)`)
};

const ru_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диапазон цен (USD)`)
};

const pt_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixa de Preço (USD)`)
};

const ko_price_range_usd = /** @type {(inputs: Price_Range_UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격대 (USD)`)
};

/**
* | output |
* | --- |
* | "Price Range (USD)" |
*
* @param {Price_Range_UsdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const price_range_usd = /** @type {((inputs?: Price_Range_UsdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Range_UsdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_range_usd(inputs)
	if (locale === "es") return es_price_range_usd(inputs)
	if (locale === "fr") return fr_price_range_usd(inputs)
	if (locale === "de") return de_price_range_usd(inputs)
	if (locale === "ja") return ja_price_range_usd(inputs)
	if (locale === "zh") return zh_price_range_usd(inputs)
	if (locale === "ar") return ar_price_range_usd(inputs)
	if (locale === "id") return id_price_range_usd(inputs)
	if (locale === "it") return it_price_range_usd(inputs)
	if (locale === "ru") return ru_price_range_usd(inputs)
	if (locale === "pt") return pt_price_range_usd(inputs)
	return ko_price_range_usd(inputs)
});